import React from 'react'
import style from './LanguageBtn.module.scss'
import { useTranslation } from 'react-i18next'

const LanguageBtn = props => {

    const { t, i18n } = useTranslation('common')

    let tranStyle
    if (i18n.language === 'en') {
        tranStyle = require('./LanguageBtn-ltr.module.scss')
    } else {
        tranStyle = require('./LanguageBtn-rtl.module.scss')
    }

    const handleLanguage = () => {
        console.log(i18n.language)
        if (i18n.language === 'en') {
            localStorage.setItem('lang', 'ar')
        } else {
            localStorage.setItem('lang', 'en')
        }
        window.location.reload()
    }
    
    return (
        <>
            <button 
                className={[
                    props.login ? style.loginLanguageBtn : style.languageBtn,
                    props.login ? tranStyle.loginLanguageBtn : null,
                ].join(' ')} 
                onClick={handleLanguage}
            >
                {i18n.language === 'en' ? 'Ar' : 'En'}
            </button>
        </>
    )

}

export default LanguageBtn